import BasePage from "./BasePage";

export default class TestRideListPage extends BasePage {
    
    public static async init() {
        await super.init();
        
        this.setList();
    }
    
    private static setList() {
        $("#Booked").on("click", function () {
            $("#Booked").attr("data-selected", "true");
            $("#Executed").attr("data-selected", "false");
            $(".executed").hide();
            $(".booked").show();
        });

        $("#Executed").on("click", function () {
            $("#Booked").attr("data-selected", "false");
            $("#Executed").attr("data-selected", "true");
            $(".booked").hide();
            $(".executed").show();            
        });
    }   
}